<template>
    <div class="row-flex">
        <span class="CodeLang font-14">{{ codeLang }}</span>
        <pre id="iframeHtml">{{ content }}</pre>
        <button class="CopyBtn font-12" @click="Copy('iframeHtml')"  title="Copy to Clipboard"><i class="mdi mdi-content-copy"></i> Copy</button> 
    </div>
</template>

<script>
import appConfig from "@/app.config";

export default {
    name: "CodeSnippet",
    page: {
        title: "code snippet",
        meta: [{ name: "description", content: appConfig.description }]
    },
    props: ["content", "codeLang"],
    data() 
    {   
        return {
        }
    },
    methods:{
        Copy(name)
        {
            const string = document.getElementById(name).innerText
            navigator.clipboard.writeText(string)
        }
    }
}
</script>

<style lang="scss" scoped>

.needed
{
    outline: 4px solid #FF6666;
}

.row-flex
{
    position: relative;
    align-items: center;
    background-color: #f4f4f4;
    padding: .75em;
    padding-top: 2em;
    border-radius: .5em;
    width: fit-content;
}

pre
{
    z-index: 1;
    white-space: pre;
    margin-bottom: .25em;
    min-height: 1.8em;
    width: fit-content;
    display: flex;
}

.CopyBtn
{
    border: none;
    background: none;
    position: absolute;
    top: 5px;
    right: 5px;
    padding-left: 1em;
    padding-right: 1em;
    border-radius: 1em;
}

.CopyBtn:hover
{
    background-color: #e4e4e4;
}

.CopyBtn:active
{
    background-color: #d4d4d4;
}


.CodeLang
{
    position: absolute;
    color: black;
    top: 5px;
}
</style>